import axios from "axios";
import { DEVELOPMENT, PRODUCTION, STAGING, STAGING2, STAGING3, TESTING } from "./constants";

const enviroment = process.env.REACT_APP_ENVIRONMENT;
// API DOMAIN
let API_DOMAIN = '127.0.0.1:8000'; // 127.0.0.1:8000
let APIwithSSL = enviroment !== 'development';

// MY DOMAIN FRONTEND

let DOMAIN_BASE = document.domain;
let URLwithSSL = false;

switch (enviroment) {
  case PRODUCTION:
      API_DOMAIN = process.env.REACT_APP_HOST_API;
      break;
  case STAGING:
      API_DOMAIN = process.env.REACT_APP_HOST_API_STAGING;
      break;
  case STAGING2:
      API_DOMAIN = process.env.REACT_APP_HOST_API_STAGING_2;
      break;
  case STAGING3:
      API_DOMAIN = process.env.REACT_APP_HOST_API_STAGING_3;
      break;
  case TESTING:
      API_DOMAIN = process.env.REACT_APP_HOST_API_TESTING;
      break;
  case DEVELOPMENT:
      if (process.env.REACT_APP_HOST_API_DEVELOPMENT) {
          API_DOMAIN = process.env.REACT_APP_HOST_API_DEVELOPMENT;
          APIwithSSL = true;
      }
      break;
  default:
      break;
}
// console.log('DOMAIN_BASE => ', DOMAIN_BASE);
DOMAIN_BASE = DOMAIN_BASE === 'localhost' ? `${DOMAIN_BASE}:3000` : DOMAIN_BASE;
console.log('DOMAIN_BASE => ', DOMAIN_BASE);


export const BACKEND_DOMAIN = APIwithSSL ? `${API_DOMAIN}` : `${API_DOMAIN}`;
export const API = APIwithSSL ? `${API_DOMAIN}/api` : `${API_DOMAIN}/api`;
export const URL_BASE = URLwithSSL ? `https://${DOMAIN_BASE}` : `http://${DOMAIN_BASE}`;

console.log(`BACKEND_DOMAIN: ${BACKEND_DOMAIN}`);
console.log(`API: ${API}`);
console.log(`URL_BASE: ${URL_BASE}`);

// const authorisation = localStorage.getItem('authorisation') ?? {};

const axiosInstance = axios.create({
  baseURL: API,
  // baseURL: `http://localhost/back-kiosko/public/api/`,
  headers: {
    'Content-Type': 'application/json',
    // Authorization: `Bearer ${token}`
  },
});

delete axiosInstance.defaults.headers.common.Authorization;
const authorisation = localStorage.getItem('authorisation') ?? {};

if (Object.values(authorisation).length > 0) {
    const { token, type } = JSON.parse(authorisation);
    axiosInstance.defaults.headers.common.Authorization = `${type} ${token}`;
}

// interceptor for http
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);


export const httpClient = axiosInstance;


// delete httpClient.defaults.headers.common.Authorization;
// if (Object.values(authorisation).length > 0) {
//     const { token, type } = JSON.parse(authorisation);
//     // axiosServices.defaults.headers.common.Authorization = `Bearer ${token}`;
//     httpClient.defaults.headers.common.Authorization = `${type} ${token}`;
// }
// // interceptor for http
// httpClient.interceptors.response.use(
//   (response) => response,
//   (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
// );
// export default httpClient;

export const clienteKiosko = axios.create({
  baseURL: `https://staging2supermercadosmia.siansystem.com/`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const clienteTipoCambio = axios.create({
  baseURL: `http://api.apis.net.pe/v1/`,
  headers: {
    "Content-Type":
      "application/x-www-form-urlencoded; charset=UTF-8;application/json",
  },
});

export const urlFoto = "http://127.0.0.1:8000/imagenes/";

// API_PRINT: API de impresion
export const API_PRINT = axios.create({
  // baseURL: `https://testsupermercadosmia.siansystem.com/admin/apiPos/signin`,
  baseURL: `https://testsupermercadosmia.siansystem.com/admin/apiPos`,
  headers: {
    'Content-Type': 'application/json',
  },
});
